import { MapObjectColors } from '../../core/map-object-colors';

/** Stable source colors and opposite hatches also distinguish overlapping cells. */
export const PullCoverageStyles = [
  { source: 'osm', label: 'OpenStreetMap', color: MapObjectColors.seaPine, angle: 45 },
  { source: 'google', label: 'Google', color: MapObjectColors.copper, angle: 135 },
] as const;
